function Tools() {
    if (!(this instanceof Tools)) {
        return new Tools();
    }

    const map = {
        groupBy([group, items]) {
            return { group, items };
        }
    }

    function groupBy(list, group, map) {
        function groupValue(item) {
            if (typeof group === 'function') {
                return group(item);
            } else if (typeof group === 'string') {
                return item[group];
            } else {
                throw `Not supported type ${typeof group}`;
            }
        }

        let groups = list.reduce(function (groups, item) {
            let key = groupValue(item);
            (groups[key] = groups[key] || []).push(item);
            return groups;
        }, {});

        return map && Object.entries(groups).map(map) || groups;
    }

    function copyOf(obj) {
        return JSON.parse(JSON.stringify(obj));
    }

    function asBlob(data, mimeType = 'application/json') {
        return new Blob([JSON.stringify(data, null, 4)], { type: mimeType });
    }

    this.map = map;
    this.groupBy = groupBy;
    this.copyOf = copyOf;
    this.asBlob = asBlob;
}

function install(Vue) {
    const tools = new Tools();

    Object.defineProperties(Vue.prototype, {
        $tools: {
            get() {
                return tools;
            }
        }
    });
}

export default install;